import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const areas = ['Glasgow City', 'Clydebank', 'Paisley', 'Renfrew', 'Bearsden', 'Milngavie', 'Bishopbriggs', 'Rutherglen', 'Cambuslang', 'East Kilbride'];
export function ServiceAreas() {
  return <section className="py-24 relative z-10 bg-[#0a0a0a]" data-id="element-210" data-mp="2prdc8ma9lxau">
      <div className="max-w-7xl mx-auto px-6" data-id="element-211" data-mp="2ppsj913lmmf3">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-212" data-mp="2brca73i9kjts">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-213" data-mp="2gs03xwxvnerp">
            <h2 className="text-3xl md:text-4xl font-black text-white mb-6" data-id="element-214" data-mp="10cj2zw51cp9">
              Areas We Cover
            </h2>
            <p className="text-gray-400 mb-8 leading-relaxed" data-id="element-215" data-mp="52fu5newafa0">
              We provide fast, reliable heating services across Greater Glasgow
              and the surrounding Clydeside areas. If your area isn't listed,
              give us a call to see if we can help.
            </p>

            <div className="flex flex-wrap gap-3" data-id="element-216" data-mp="fzkm14senwa6">
              {areas.map((area, index) => <div key={index} className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm text-gray-300" data-id="element-217" data-mp="b110h5hq4mic" data-mpi={index}>
                  <MapPin className="w-4 h-4 text-[#FF9500]" data-id="element-218" data-mp="3ehpyg338qnwe" />
                  {area}
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-card border border-white/10 rounded-3xl h-[400px] relative overflow-hidden" data-id="element-219" data-mp="3tcnqeuuh9bcy">
            <iframe title="Clydeside Gas Safe Heating service area — Glasgow" className="w-full h-full grayscale-[0.2] invert-[0.92] hue-rotate-180 contrast-[0.9]" src="https://www.openstreetmap.org/export/embed.html?bbox=-4.5000%2C55.7700%2C-4.0500%2C55.9400&layer=mapnik&marker=55.8642%2C-4.2518" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-220" data-mp="1as3a4jfoo2g3"></iframe>

            {/* Location Label */}
            <div className="absolute bottom-4 left-4 right-4 bg-[#0a0a0a]/90 backdrop-blur-md border border-white/10 rounded-2xl px-4 py-3 flex items-center gap-3 pointer-events-none" data-id="element-221" data-mp="x1zxmk6lvn3u">
              <div className="w-10 h-10 rounded-full bg-gradient-primary p-[1px] flex-shrink-0" data-id="element-222" data-mp="16s2yf6jyy5cq">
                <div className="w-full h-full bg-[#0a0a0a] rounded-full flex items-center justify-center" data-id="element-223" data-mp="9akpgas5ebko">
                  <MapPin className="w-5 h-5 text-[#FF9500]" data-id="element-224" data-mp="e9p075uq0hd4" />
                </div>
              </div>
              <div data-id="element-225" data-mp="2rjp23ez461jl">
                <p className="text-white font-bold text-sm leading-tight" data-id="element-226" data-mp="2rk74yuga7e0h">
                  Clydeside Gas Safe Heating
                </p>
                <p className="text-gray-400 text-xs" data-id="element-227" data-mp="2ik1yqnmtqlnw">
                  Based in Glasgow, Scotland
                </p>
              </div>
            </div>

            <a href="https://www.openstreetmap.org/?mlat=55.8642&mlon=-4.2518#map=12/55.8642/-4.2518" target="_blank" rel="noopener noreferrer" className="absolute top-4 right-4 bg-[#0a0a0a]/90 backdrop-blur-md border border-white/10 rounded-full px-4 py-2 text-xs font-semibold text-[#FFD600] hover:bg-[#FFD600] hover:text-black transition-colors" data-id="element-228" data-mp="2dkz47x4gzxu6">
              Open in Maps
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}